import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
const Loading = (props) => {
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames('loader', { full: !props.inline }, 'visible') }, window.appmode ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "ldio-hn0fflew9qp" },
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null)),
            React.createElement("div", { className: "loadingmessage" }, t('app.checkout.loading')))) : (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "loader__dot" }),
            React.createElement("span", { className: "loader__dot" }),
            React.createElement("span", { className: "loader__dot" }))))));
};
export default Loading;
